module.exports = __webpack_public_path__ + "images/emoji/coffee.19907494d7c76d8db90b.png";